<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="brandProgramForm" :model="brandProgramForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="品牌">
             <el-input clearable v-model="brandProgramForm.nameLike"  placeholder="请输入品牌名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="分类">
             <el-select clearable v-model="brandProgramForm.categoryId" placeholder="请选择">
                <el-option
                  v-for="item in prentIdOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getbrandThreeList">查询</el-button>
            <el-button type="primary" @click="addCtiy">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="value"
            label="编号">
          </el-table-column>
          <el-table-column
            prop="name"
            label="品牌">
          </el-table-column>
          <el-table-column
            prop="categoryName"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="status"
            label="前端展示">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">展示</span>
              <span v-else>不展示</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorbrand(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="changeStatus(scope.row, 1)" type="text" size="small" v-if="scope.row.status === 0">展示</el-button>
                <el-button @click="changeStatus(scope.row, 0)" type="text" size="small" style="color: red;" v-else>不展示</el-button>
                <el-button @click="upDownMove(scope.row.id,scope.$index - 1)" type="text" size="small" v-if="scope.$index>0">上移</el-button>
                <el-button @click="upDownMove(scope.row.id,scope.$index + 1)" type="text" size="small" v-if="scope.$index < tableData.length-1">下移</el-button>
                <el-button @click="upDownMove(scope.row.id,0, true)" type="text" size="small" >置顶</el-button>
                <el-button @click="upDownMove(scope.row.id,-1, true)" type="text" size="small" >置底</el-button>
                <el-button @click="deleteLinkage(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button> 
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑品牌' : '新建品牌'" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editBrandForm" :model="editBrandForm" :rules="editorFormRules" label-width="120px">
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input clearable v-model="editBrandForm.value" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="品牌" prop="name">
              <el-input clearable v-model="editBrandForm.name"></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="parentId">
              <el-select clearable v-model="editBrandForm.parentId" placeholder="请选择">
                <el-option
                  v-for="item in prentIdOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorbrandDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      brandProgramForm: {
        categoryId: '',
        nameLike: '',
        typeKey: 'phoneBrand',
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      typeKey: 'phoneBrand',
      pageSize: 10,
      currentPage: 1,


      // 新建编辑对话框数据

      isDlg: false,
      editBrandForm: {
        id: null,
        value: null,
        name: null,
        typeKey: 'phoneBrand',
        parentId: null,
      },

      editorFormRules: {
        name: [
          { required: true, message: '请输入品牌', trigger: 'change' },
        ],
        parentId: [
          { required: true, message: '请选择分类', trigger: 'change' },
        ]
      },


      dlgType: 'change',

      // 选择
      brandOptions: [],
      loading: false,

      prentIdOptions: [],
    }
  },
  watch:{},
  computed:{},
  methods:{
      deleteLinkage(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteLinkage({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getbrandThreeList()
          }
      })
      })
    },
      // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val

      // 重新请求表格数据
      this.getbrandThreeList()
    }, 

    // 获取表格数据
    getbrandThreeList() {
      let self  = this;
      self.$api.getClass({
        typeKey: self.typeKey,
        page: self.currentPage,
        size: self.pageSize,
        categoryId: self.brandProgramForm.categoryId || null,
        nameLike: self.brandProgramForm.nameLike || null,
      }).then(res => {

        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加
    addCtiy() {
      this.dlgType = 'new'
      this.editBrandForm=this.$options.data().editBrandForm;
      this.$nextTick(()=>{
          this.$refs['editBrandForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改
    editorbrand(row) {
      let self = this;
      self.editBrandForm = {
        id: null,
        value: null,
        name: null,
        typeKey: 'phoneBrand',
        parentId: null,
      }

      self.dlgType = 'change'

      for(let i in self.editBrandForm) {
        if(i === 'parentId') {
          self.editBrandForm[i] = row.categoryId
        } else {
          if(row[i])self.editBrandForm[i] = row[i]
        }
      }
      console.log(self.brandOptions);
      self.isDlg = true
    },

    // 关闭编辑对话框
    closeEditorbrandDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editBrandForm'].validate((valid) => {
        if (valid) {
          let params = {}
          for(let i in self.editBrandForm) {
            if(i === 'commission' && this.editBrandForm[i]) {
              params[i] = parseFloat(this.editBrandForm[i], 10)
            } else {
              params[i] = this.editBrandForm[i]
            }
          }
          if(self.dlgType === 'change') {
            self.$api.changeLinkage(params.id, params).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getbrandThreeList()
                this.closeEditorbrandDlg()
              }
            })
          } else {
            self.$api.addLinkage(params).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getbrandThreeList()
                this.closeEditorbrandDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

    // 请求分类列表，提供编辑时选择用
    initAreaFirstData() {
      let self = this;
      self.$api.getClass({
        typeKey: 'category',
        status: 1,
        page: 1,
        size: 100000,
      }).then(res => {
        if(res.code === 200) {
          self.prentIdOptions = res.data.records
        }
      })
    },

    changeStatus(row, newStatus) {
      let self = this
      self.$api.changeLinkage(row.id, {
        name: row.name,
        status: newStatus,
        typeKey: 'phoneBrand',
      }).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.getbrandThreeList()
        }
      })
    },

    upDownMove(id, toIndex, type) {
      let self = this;
      self.$api.changeLinkageOrder({
        currentId: id,
        swapId: type ? toIndex: self.tableData[toIndex].id
      }).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '移动成功',
            type: 'success'
          });
          self.getbrandThreeList()
        }
      })
    }

  },
  created(){},
  mounted(){
    let self = this;
    self.getbrandThreeList()
    self.initAreaFirstData()
  }
}
</script>
<style lang="less" scoped>
</style>